export const COVER_MAP_IDS = ['terra', 'topographic', 'heat', 'moon-base'] as const;
export const COVER_FORMATS = ['landscape', 'portrait'] as const;
export type CoverFormat = typeof COVER_FORMATS[number];

export function coverFormat(width: number, height: number): CoverFormat {
  return width >= height ? 'landscape' : 'portrait';
}

export function coverSampleId(map: string, format: CoverFormat) {
  return `cover-${map}-${format}`;
}

export function coverPreset(format: CoverFormat) {
  return format === 'landscape' ? 'landscape-16x9' : 'vertical-9x16';
}
